<template>
  <div :class="[is_subrow ? '' : 'row']">
    <template v-for="row in current_fields">
      <!-- <div class="row" :class="[row.classes]" :key="'row'+i"> -->
      <template v-for="(item, k) in row.items">
        <!-- <div :class="item.classes" :key="'col'+k"> -->
        <h6
          :class="item.classes"
          v-if="item.type == 'h'"
          :key="k"
          v-html="$t(item.label)"
        ></h6>

        <div :key="k" v-if="item.type == 'product-repeater'">
          <sad-product-field
            :classes="item.classes"
            :id="item.id"
            :current_fields="item.items"
            :gtd="gtd"
            :errors="errors"
          ></sad-product-field>
        </div>

        <div :key="k" v-if="item.type == 'table'">
          <sad-table-field
            :classes="item.classes"
            :id="item.id"
            :product_index="product_index"
            :product="product"
            :options="item"
            :gtd="gtd"
            :errors="errors"
          ></sad-table-field>
        </div>

        <div
          :key="'row' + item.id + uid + k"
          v-if="item.type == 'row'"
          :class="item.classes"
        >
          <form-sad-subitems
            :is_in_product="is_in_product"
            :product_index="product_index"
            :product="product"
            :current_fields="[item]"
            :is_subrow="true"
            :gtd="gtd"
            :errors="errors"
          />
        </div>

        <div
          :key="item.id + uid + k"
          v-if="item.type == 'col'"
          :class="item.classes"
        >
          <form-sad-subitems
            :is_in_product="is_in_product"
            :product_index="product_index"
            :product="product"
            :current_fields="[item]"
            :gtd="gtd"
            :errors="errors"
          />
        </div>

        <div
          :key="item.id + uid + k"
          v-if="item.type == 'div'"
          :class="item.classes"
        >
          <form-sad-subitems
            v-if="item.items && item.items.length > 0"
            :is_in_product="is_in_product"
            :product_index="product_index"
            :product="product"
            :current_fields="[item]"
            :gtd="gtd"
            :errors="errors"
          />
          <div v-else>{{ item.label }}</div>
        </div>

        <div
          :key="item.id + uid + k"
          v-if="item.type == 'v-select'"
          :class="[item.classes, has_error(item.model) ? 'has-danger' : '']"
        >
          <v-select-popup
            v-if="is_in_product"
            :not_translated="true"
            :readonly="item.options.readonly"
            :type="item.options.request"
            :indata="item.options.indata"
            v-model="product[item.model]"
            :placeholder="$t(item.label)"
          />
          <v-select-popup
            v-else
            :not_translated="true"
            :readonly="item.options.readonly"
            :type="item.options.request"
            :indata="item.options.indata"
            v-model="gtd[item.model]"
            :placeholder="$t(item.label)"
          />
        </div>
        <div
          :key="item.id + uid + k"
          v-if="item.type == 'tnved'"
          :class="[item.classes, has_error(item.model) ? 'has-danger' : '']"
        >
          <tnved
            v-if="is_in_product"
            :placeholder="$t(item.label)"
            :readonly="item.options.readonly"
            :placeholder_name="$t(item.options.name)"
            :placeholder_code="$t(item.options.code)"
            v-model="product[item.model]"
          ></tnved>
          <tnved
            v-else
            :placeholder="item.label"
            :readonly="item.options.readonly"
            :placeholder_name="$t(item.options.name)"
            :placeholder_code="$t(item.options.code)"
            v-model="gtd[item.model]"
          ></tnved>
        </div>

        <div
          v-if="item.type == 'text'"
          :key="item.id + uid + k"
          :class="[item.classes, has_error(item.model) ? 'has-danger' : '']"
        >
          <span
            :class="[
              'bmd-form-group mb-2 d-block ',
              item.options.noformlabel == true ? '' : 'form-label-group',
              has_error(item.model) ? 'has-danger' : '',
            ]"
          >
            <input
              v-if="is_in_product"
              type="text"
              :readonly="item.options.readonly"
              class="form-control"
              :class="item.options.inputclass"
              v-model="product[item.model]"
              :placeholder="$t(item.label)"
              :maxlength="item.options.maxlength"
              autocomplete="off"
              style="cursor: auto"
              :id="
                item.id
                  ? item.id + '-' + product_index
                  : uid + k + '-' + product_index
              "
            />
            <input
              v-else
              type="text"
              :readonly="item.options.readonly"
              class="form-control"
              :class="item.options.inputclass"
              v-model="gtd[item.model]"
              :placeholder="$t(item.label)"
              :maxlength="item.options.maxlength"
              autocomplete="off"
              style="cursor: auto"
              :id="
                item.id
                  ? item.id + '-' + product_index
                  : uid + k + '-' + product_index
              "
            />
            <label
              :for="
                item.id
                  ? item.id + '-' + product_index
                  : uid + k + '-' + product_index
              "
              class="form-label-group-label shorter"
              :class="item.options.labelclass"
            >
              <span v-html="form_label(item)"></span>
              <template v-if="item && item.options && item.options.description">
                <span
                  class="field_description"
                  v-tippy="{ arrow: true, theme: 'light-border' }"
                  :content="$t(item.options.description)"
                  ><i class="fa fa-question-circle"></i
                ></span>
              </template>
            </label>
          </span>
        </div>

        <div
          v-if="item.type == 'address'"
          :key="item.id + uid + k"
          :class="[item.classes, has_error(item.model) ? 'has-danger' : '']"
        >
          <address-field
            v-if="is_in_product"
            :readonly="item.options.readonly"
            v-model="product[item.model]"
            :label="$t(item.label)"
          ></address-field>
          <address-field
            v-else
            :readonly="item.options.readonly"
            v-model="gtd[item.model]"
            :label="$t(item.label)"
          ></address-field>
        </div>

        <div
          v-if="item.type == 'datepicker'"
          :key="item.id + uid + k"
          :class="[item.classes, has_error(item.model) ? 'has-danger' : '']"
        >
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              has_error(item.model) ? 'has-danger' : '',
            ]"
          >
            <datepicker
              v-if="is_in_product"
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="product[item.model] = ' '"
              @blur="
                product[item.model] == ' '
                  ? (product[item.model] = '')
                  : (product[item.model] = product[item.model])
              "
              inputClass="form-control"
              :readonly="item.options.readonly"
              v-model="product[item.model]"
              :placeholder="$t(item.label)"
              :inputAttr="{ id: item.id + '-' + product_index }"
            />
            <datepicker
              v-else
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="gtd[item.model] = ' '"
              @blur="
                gtd[item.model] == ' '
                  ? (gtd[item.model] = '')
                  : (gtd[item.model] = gtd[item.model])
              "
              inputClass="form-control"
              :readonly="item.options.readonly"
              v-model="gtd[item.model]"
              :placeholder="$t(item.label)"
              :inputAttr="{ id: item.id + '-' + product_index }"
            />
            <label
              :for="item.id + '-' + product_index"
              class="form-label-group-label shorter"
              :class="[
                gtd[item.model] != '' && gtd[item.model] != null
                  ? 'topped'
                  : '',
                item.options.labelclass,
              ]"
            >
              <span v-html="form_label(item)"></span>
              <template v-if="item && item.options && item.options.description">
                <span
                  class="field_description"
                  v-tippy="{ arrow: true, theme: 'light-border' }"
                  :content="$t(item.options.description)"
                  ><i class="fa fa-question-circle"></i
                ></span>
              </template>
            </label>
          </span>
        </div>

        <div
          :key="item.id + uid + k"
          v-if="item.type == 'cleave'"
          :class="item.classes"
        >
          <span
            :class="[
              'bmd-form-group mb-1 d-block form-label-group',
              has_error(item.model) ? 'has-danger' : '',
            ]"
          >
            <label
              v-if="is_in_product"
              :for="item.id + '-' + product_index"
              :class="[
                'form-label-group-label shorter',
                product[item.model] != '' ? 'high' : '',
                item.options.labelclass,
              ]"
            >
              <span v-html="form_label(item)"></span>
              <template v-if="item && item.options && item.options.description">
                <span
                  class="field_description"
                  v-tippy="{ arrow: true, theme: 'light-border' }"
                  :content="$t(item.options.description)"
                  ><i class="fa fa-question-circle"></i
                ></span>
              </template>
            </label>
            <label
              v-else
              :for="item.id + '-' + product_index"
              :class="[
                'form-label-group-label shorter',
                gtd[item.model] != '' ? 'high' : '',
                item.options.labelclass,
              ]"
            >
              <span v-html="form_label(item)"></span>
              <template v-if="item && item.options && item.options.description">
                <span
                  class="field_description"
                  v-tippy="{ arrow: true, theme: 'light-border' }"
                  :content="$t(item.options.description)"
                  ><i class="fa fa-question-circle"></i
                ></span>
              </template>
            </label>
            <cleave
              v-if="is_in_product"
              v-model="product[item.model]"
              :readonly="item.options.readonly"
              :options="item.options.cleave"
              :id="item.id + '-' + product_index"
              class="form-control"
              :placeholder="$t(item.label)"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
            <cleave
              v-else
              v-model="gtd[item.model]"
              :readonly="item.options.readonly"
              :options="item.options.cleave"
              :id="item.id + '-' + product_index"
              class="form-control"
              :placeholder="$t(item.label)"
              autocomplete="off"
              style="cursor: auto"
            ></cleave>
          </span>
        </div>
        <div
          :key="item.id + uid + k"
          v-if="item.type == 'switch'"
          :class="item.classes"
        >
          <div
            v-if="is_in_product"
            class="togglebutton other mt-md-3 form-label-group"
          >
            <label class="control-label-sm">
              <span>{{ $t(item.label) }}</span
              ><br /><br />
              <input
                type="checkbox"
                :readonly="item.options.readonly"
                v-model="product[item.model]"
              />
              <span class="toggle"></span>
              <span class="choise_2">{{ $t(item.options.choice_2) }}</span>
              <span class="choise_1">{{ $t(item.options.choice_1) }}</span>
            </label>
          </div>
          <div v-else class="togglebutton other mt-md-3 form-label-group">
            <label class="control-label-sm">
              <span>{{ $t(item.label) }}</span
              ><br /><br />
              <input
                type="checkbox"
                :readonly="item.options.readonly"
                v-model="gtd[item.model]"
              />
              <span class="toggle"></span>
              <span class="choise_2">{{ $t(item.options.choice_2) }}</span>
              <span class="choise_1">{{ $t(item.options.choice_1) }}</span>
            </label>
          </div>
        </div>

        <!--
                            + add label classes
                            + add tab index option (to navigate with tabs)
                            + add is_fillable checks
                        -->
        <!-- </div> -->
      </template>
      <!-- </div> -->
    </template>
  </div>
</template>

<script>
// import FormSadSubitems from './form-sad-subitems.vue'
// import SadProductField from './../fields/sad-product-field.vue'
export default {
  name: "form-sad-subitems",
  // components: {FormSadSubitems, SadProductField},
  props: {
    current_fields: {
      type: Array,
    },
    product: {
      type: Object,
      default: () => {
        return {};
      },
    },
    gtd: {
      type: Object,
    },
    is_subrow: {
      type: Boolean,
      default: false,
    },
    product_index: {
      type: Number,
      default: 0,
    },
    is_in_product: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    uid() {
      return this._uid;
    },
  },
  mounted() {
    // console.log(this.current_fields)
  },
  methods: {
    has_error(id) {
      if (this.errors.includes(id)) return true;
      return false;
    },
    form_label(item) {
      let result = this.$t(item.label);
      return result;
    },
  },
};
</script>

<style scoped>
.ultrasmall_underfield {
  font-size: 8px !important;
  word-break: break-all;
}
.ch-px-3 .row {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.field_description svg {
  cursor: pointer;
  color: #007bff;
  fill: #007bff;
}
</style>
